<template>
	<div class="container">
		<el-row style="text-align: left;padding: 0.1rem 0.32rem;">
		</el-row>
		<el-row class="content">
			<el-row type="flex" class="row-bg">

				<el-col :span="18"><b>{{content.title}}</b></el-col>
			</el-row>
			<el-row type="flex" class="row-bg" style="margin-top:0.2rem">

				<el-col :span="18"><b>{{content.content}}</b></el-col>
			</el-row>


			<el-form label-position="top" label-width="80px" :model="formLabelAlign" style="margin-top:0.2rem">
				<el-form-item label="NTL 2019年4月30日">
					<el-input v-model="formLabelAlign.name"></el-input>
				</el-form-item>
				<el-form-item label="附件">
					<el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :on-preview="handlePictureCardPreview"
					 :on-remove="handleRemove">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible" size="tiny">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<el-form-item label="提问 2019年4月30日">
					<el-input v-model="formLabelAlign.name"></el-input>
				</el-form-item>
				<el-form-item label="NTL 2019年4月30日">
					<el-input v-model="formLabelAlign.name"></el-input>
				</el-form-item>

				<el-form-item style="text-align: center;margin-top: 0.3rem;margin-bottom:3em">
					<el-button type="primary" style="width:2rem">回复</el-button>
				</el-form-item>
			</el-form>
		</el-row>

	</div>
</template>

<script>
	import {
		getMessageDefault,
		setRead
	} from '@/api/message.js'
	export default {
		data() {
			return {
				formLabelAlign: {
					name: '',
					region: '',
					type: '',
					date: ''
				},
				dialogImageUrl: '',
				dialogVisible: false,
				id: null,
				content: {
					content: null,
					id: null,
					read: null,
					title: null,
					userName: null,
					version: null
				}
			};
		},
		created() {

		},
		methods: {
			// 根据id查询信息
			getInfo() {
				let that = this
				getMessageDefault(this.id).then(res => {
					that.content = res.data
				})
			},
			// 设置当前消息为已读
			setCoreRead() {
				setRead(this.id).then(res => {
					console.log("设置已读成功！")
				})
			},

			onSubmit() {

			},
			cancels() {
				this.$router.push("/newsCase")
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			}
		},
		mounted() {
			// 打印父组件传入的id值
			// console.log(this.$route.query)
			this.id = this.$route.query['id']
			// 获取数据
			this.getInfo();
			this.setCoreRead();
		}
	}
</script>

<style scoped>
	.el-form-item {
		text-align: left;
		margin-top: 0.1rem;
		margin-bottom: 0px;
	}

	<<<<<<< .mine .el-form-item__label {
		line-height: 0.4rem;

	}

	.container {
		max-width: 500px;
		margin: auto;
		background: #fff;
	}

	.el-col {
		padding: 0;
		text-align: left;
	}

	.el-row {
		padding: 0;
		margin-bottom: 0.1rem;
	}

	.content {
		padding: 0 0.32rem;
	}

	.el-upload-list--picture-card .el-upload-list__item,
	div.el-upload--picture-card {
		width: 1rem;
		height: 1rem;
		line-height: 1rem;
	}

	.el-button--primary {
		color: #FFF;
		background-color: #3bb30a;
		border-color: #3bb30a;
	}
</style>
||||||| .r9285
.el-form-item__label {
line-height: 0.4rem;

}
.container {
max-width: 500px;
margin:auto;
background: #fff;
}
.el-col{
padding:0;
text-align: left;
}
.el-row{
padding:0;
margin-bottom: 0.1rem;
}
.content{
padding:0 0.32rem;
}
.el-upload-list--picture-card .el-upload-list__item,div.el-upload--picture-card{
width: 1rem;
height: 1rem;
line-height: 1rem;
}

.el-button--primary {
color: #FFF;
background-color: #3bb30a;
border-color: #3bb30a;
}
</style>
=======
.el-form-item__label {
line-height: 0.4rem;

}
.container {
max-width: 500px;
margin:auto;
background: #fff;
margin-left: 10px;
margin-right: 10px;
}
.el-col{
padding:0;
text-align: left;
}
.el-row{
padding:0;
margin-bottom: 0.1rem;
}
.content{
padding:0 0.32rem;
}
.el-upload-list--picture-card .el-upload-list__item,div.el-upload--picture-card{
width: 1rem;
height: 1rem;
line-height: 1rem;
}

.el-button--primary {
color: #FFF;
background-color: #3bb30a;
border-color: #3bb30a;
}
</style>
>>>>>>> .r9290
